// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".theme--light.v-application[data-v-2764b9e5] {\n  background: #ffffff !important;\n}\n.date-picker-card-text[data-v-2764b9e5] {\n  max-height: calc(100vh - 100px);\n  overflow-x: hidden;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
